import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-supermix-apply-label',
  standalone: true,
  imports: [],
  templateUrl: './supermix-apply-label.component.html',
  styleUrl: './supermix-apply-label.component.scss'
})
export class SupermixApplyLabelComponent implements OnInit {
  @Output() showMoreClick = new EventEmitter();
  @Input() options: { applied: boolean, showMore: boolean } = { applied: false, showMore: false };
  public label: string;
  ngOnInit(): void {
    this.getLabel();
  }

  public getLabel(): void {
    this.label = `Súper Mix ${this.options.applied ? 'aplicado' : 'disponible'}`;
  }

  public showMore(): void {
    this.showMoreClick.emit();

  }
}
